import { SystemStyleObject } from "@chakra-ui/react";

export const businessDetailsQuickActionBtnCss: SystemStyleObject = {
  border: "1px solid #D0D5DD",
  height: "40px",
  borderRadius: "8px",
  padding: "10px 18px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
  boxShadow: "0px 1px 2px 0px #1018280D",
};

export const moreQuickActionsDropDownPopUpMenuContentCss: SystemStyleObject = {
  borderRadius: "8px",
  backgroundColor: "#ffffff",
  border: "1px solid #F2F4F7",
  padding: "0 16px",
  boxShadow: "0px 12px 16px -4px #10182814",
};

export const transactionLimitModalHeaderCss: SystemStyleObject = {
  marginBottom: 0,
};

export const emailNotificationSwitchInputCss: SystemStyleObject = {
  opacity: 0,
  width: 0,
  height: 0,

  "&:checked + span": {
    backgroundColor: "#00535C",
  },

  "&:checked + span::before": {
    transform: "translateX(20px)",
  },
};

export const emailNotificationSwitchSliderCss: SystemStyleObject = {
  position: "absolute",
  cursor: "pointer",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "#E5E7EB",
  padding: "2px",
  borderRadius: "12px",
  transition: "background-color 0.3s",

  "&::before": {
    content: '""',
    position: "absolute",
    height: "20px",
    width: "20px",
    left: "2px",
    bottom: "2px",
    backgroundColor: "#ffffff",
    borderRadius: "50%",
    boxShadow: "0px 1px 3px 0px #1018281A",
    transition: "transform 0.3s",
  },
};
